module.exports = __webpack_public_path__ + "media/assets/img/white-transp-deny-d3165cbaa335464dad64e5125ea76c3f.png";